import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { optionColor } from "./Badges";
import { TrendingUp } from "lucide-react";

const AcceptanceChart = ({ data = [], totalAccepted = 0 }) => {
  if (!data.length || totalAccepted === 0) {
    return (
      <div className="rounded-2xl bg-white border border-slate-200 p-6" data-testid="acceptance-chart-empty">
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center">
            <TrendingUp size={15} className="text-emerald-600" />
          </div>
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-600">Preferencias</p>
        </div>
        <h3 className="font-serif-display text-xl font-bold text-slate-900">Aún sin datos</h3>
        <p className="text-xs text-slate-500 mt-1">Cuando los pasajeros comiencen a elegir opciones vas a ver la distribución acá.</p>
      </div>
    );
  }

  const chartData = data.map((d) => ({
    name: d.option,
    value: d.count,
    percentage: d.percentage,
    fill: d.option && d.option !== "(sin opción)" ? optionColor(d.option) : "#94A3B8",
  }));

  return (
    <div className="rounded-2xl bg-white border border-slate-200 p-6" data-testid="acceptance-chart">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <div className="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center">
              <TrendingUp size={15} className="text-emerald-600" />
            </div>
            <p className="text-xs font-bold uppercase tracking-widest text-emerald-600">Estadísticas de aceptación</p>
          </div>
          <h3 className="font-serif-display text-xl font-bold text-slate-900">¿Qué opción eligen más?</h3>
          <p className="text-xs text-slate-500 mt-1">{totalAccepted} cotizacion{totalAccepted !== 1 ? "es" : ""} aceptada{totalAccepted !== 1 ? "s" : ""}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center">
        <div className="h-44">
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                nameKey="name"
                innerRadius={40}
                outerRadius={72}
                paddingAngle={2}
                stroke="#fff"
                strokeWidth={2}
              >
                {chartData.map((e, i) => (
                  <Cell key={i} fill={e.fill} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{ borderRadius: 8, fontSize: 12, border: "1px solid #E2E8F0" }}
                formatter={(v, n) => [`${v} (${chartData.find(d => d.name === n)?.percentage}%)`, `Opción ${n}`]}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div className="space-y-2">
          {chartData.map((d) => (
            <div key={d.name} className="flex items-center gap-2" data-testid={`chart-legend-${d.name}`}>
              <span className="w-3 h-3 rounded" style={{ backgroundColor: d.fill }} />
              <span className="text-sm font-semibold text-slate-900 flex-1 truncate">
                {d.name === "(sin opción)" ? "Sin opción" : `Opción ${d.name}`}
              </span>
              <span className="text-xs text-slate-500 font-mono-2">{d.percentage}%</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AcceptanceChart;
